import { defineMessages } from "react-intl";

import { node as access } from "src/modules/ktx/forms/basic-registration-data/waiting-list-data/access";
import { node as graftloss } from "src/modules/ktx/forms/basic-registration-data/waiting-list-data/graftloss";
import { node as kidneyDiseaseEthiology } from "src/modules/ktx/forms/basic-registration-data/waiting-list-data/kidneyDiseaseEthiology";
import { node as renalReplacementTherapy } from "src/modules/ktx/forms/basic-registration-data/waiting-list-data/renalReplacementTherapy";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.waiting_list",
		defaultMessage: "Várólista adatok"
	}
});

export const node: ParentNode = {
	id: "ktx-waiting-list",
	value: { type: "wizard", title: messages.title },
	children: [
		kidneyDiseaseEthiology,
		renalReplacementTherapy,
		access,
		graftloss
	]
};
